import { N26OktaAuth, type N26OktaAuthConfig } from '@n26/okta-auth-client'

export const initOktaAuth = (): N26OktaAuth => {
  const config: N26OktaAuthConfig = {
    clientId: import.meta.env.VITE_OKTA_CLIENT_ID ?? '',
    issuer: import.meta.env.VITE_OKTA_ISSUER ?? '',
    redirectUri: `${window.location.origin}/login/callback`,
  }

  return new N26OktaAuth(config)
}
